import { useTheme } from './contexts/ThemeContext';
import { App as Antd, ConfigProvider } from 'antd';
import { ConfigProvider as MobileAntDesignConfigProvider } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import enUSAntd from 'antd/locale/en_US';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { GlobalStyles } from './GlobalStyles';

export const ApplicationThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const { themeAlgorithm, customTheme, combinedTheme } = useTheme();

  return (
    // App sits inside ConfigProvider so that the modal, message and notification holders it renders are built with
    // the configured theme. Outside it they fall back to the light default, which is what dark mode showed before.
    <ConfigProvider
      theme={{ algorithm: themeAlgorithm, ...customTheme }}
      locale={enUSAntd}
      modal={{ mask: { blur: false } }}
      drawer={{ mask: { blur: false } }}
    >
      <Antd>
        <StyledThemeProvider theme={combinedTheme}>
          <MobileAntDesignConfigProvider locale={enUS}>
            <GlobalStyles theme={combinedTheme} />
            {children}
          </MobileAntDesignConfigProvider>
        </StyledThemeProvider>
      </Antd>
    </ConfigProvider>
  );
};
